const LETTER_WIDTH_MM = 215.9;
const LETTER_HEIGHT_MM = 279.4;
const MM_TO_PX = 3.77952755906;

/**
 * Converts mm to pixels
 * @param mm - The number of mm to convert
 * @returns The number of pixels
 */
function mmToPixels(mm: number) {
  return mm * MM_TO_PX;
}

/**
 * Converts pixels to mm
 * @param pixels - The number of pixels to convert
 * @returns The number of mm
 *
 * Note: This function is not used in the project, it is only here for reference.
 */
// const _pixelsToMm = (pixels: number) => {
//   return pixels / MM_TO_PX;
// };

/**
 * Returns the size of the frame in mm
 * @param orientation - The orientation of the frame
 * @returns The size of the frame in mm
 */
const getFrameSizeInMm = (orientation: 'portrait' | 'landscape' = 'portrait') => {
  return orientation === 'portrait'
    ? { width: `${LETTER_WIDTH_MM}mm`, height: `${LETTER_HEIGHT_MM}mm` }
    : { width: `${LETTER_HEIGHT_MM}mm`, height: `${LETTER_WIDTH_MM}mm` };
};

/**
 * Returns the size of the iframe in mm
 * @param orientation - The orientation of the iframe
 * @returns The size of the iframe in mm
 */
const getMmByOrientation = (orientation: 'portrait' | 'landscape' = 'portrait') => {
  const width = orientation === 'portrait' ? LETTER_WIDTH_MM : LETTER_HEIGHT_MM;
  const height = orientation === 'portrait' ? LETTER_HEIGHT_MM : LETTER_WIDTH_MM;

  return {
    width: width,
    height: height,
  };
};

/**
 * Returns the size of the iframe in pixels
 * @param orientation - The orientation of the iframe
 * @returns The size of the iframe in pixels
 */
const getPixelsByOrientation = (orientation: 'portrait' | 'landscape' = 'portrait') => {
  const { width, height } = getMmByOrientation(orientation);
  return {
    width: mmToPixels(width),
    height: mmToPixels(height),
  };
};

/**
 * Returns the size of the iframe in pixels and mm
 * @param orientation - The orientation of the iframe
 * @returns The size of the iframe in pixels and mm
 */
const frameSizeByOrientation = (orientation: 'portrait' | 'landscape' = 'portrait') => {
  return {
    pixels: getPixelsByOrientation(orientation),
    mm: getMmByOrientation(orientation),
  };
};

export {
  frameSizeByOrientation,
  getFrameSizeInMm,
  getMmByOrientation,
  getPixelsByOrientation,
  mmToPixels,
};
